// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otherservicefirstpage-container {
  display: flex;
  height: 140%;
  width: 100%;
  overflow: hidden;
  padding: 0px;
  position: relative;
  box-sizing: border-box;
  min-height: calc(100vh - nav-height);
}

.image-section {
  width: 80% !important;
  position: relative;
  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
}

.otherservicefirstpage-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.otherservicefirstpage-text-section {
  width: 85%;
  background-color: #00a1da;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);
  margin-left: -6%;
}

.otherservicefirstpage-container::before {
  content: "";
  position: absolute;
  z-index: 2;
  background: linear-gradient(to bottom right, #00a1da, rgba(214, 215, 219, 0));
  pointer-events: none;
  left: 45.5% !important;
  width: 3%;
  height: 150%;
  top: -25%;
  transform: skewX(-8deg) translate(-5px, 10px);
}

.otherservicefirstpage-text-section h1 {
  font-size: 3em;
  margin-top: -20px;
  margin-bottom: 10px;
  z-index: 3;
  font-family: Arial, Helvetica, sans-serif;
}

.otherservicefirstpage-text-section p {
  font-size: 1.5em;
  text-align: center;
  padding: 0 20px;
  z-index: 3;
}

.container {
  display: flex;
  flex-direction: row;
  padding: 20px;
  gap: 20px;
}

.image-wrapper {
  flex: 1 1;
}

.image {
  width: 100%;
  max-width: 400px;
  border-radius: 8px;
}

.text-wrapper {
  flex: 2 1;
  padding: 10px;
}

.info-section {
  margin: 20px 0;
}

@media (max-width: 768px) {
  .otherservicefirstpage-container {
    flex-direction: column;
    height: auto;
  }

  .otherservicefirstpage-image-section {
    width: 100%;
    height: 55vh;
    clip-path: none;
  }

  .otherservicefirstpage-text-section {
    width: 100%;
    height: 40vh;
    margin-top: 0px;
    margin-left: 0;
    clip-path: none;
    padding: 0px;
  }

  .otherservicefirstpage-text-section h1 {
    font-size: 2em;
    margin-right: 100px;
  }

  .otherservicefirstpage-text-section p {
    font-size: 1em;
    margin-left: 5px;
    text-align: left;
  }

  .otherservicefirstpage-container::before {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/OtherServiceFirst/OtherServiceFirst.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,6EAA6E;EAC7E,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".otherservicefirstpage-container {\n  display: flex;\n  height: 140%;\n  width: 100%;\n  overflow: hidden;\n  padding: 0px;\n  position: relative;\n  box-sizing: border-box;\n  min-height: calc(100vh - nav-height);\n}\n\n.image-section {\n  width: 80% !important;\n  position: relative;\n  clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);\n}\n\n.otherservicefirstpage-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.otherservicefirstpage-text-section {\n  width: 85%;\n  background-color: #00a1da;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  clip-path: polygon(10% 0, 100% 0, 100% 100%, 0% 100%);\n  margin-left: -6%;\n}\n\n.otherservicefirstpage-container::before {\n  content: \"\";\n  position: absolute;\n  z-index: 2;\n  background: linear-gradient(to bottom right, #00a1da, rgba(214, 215, 219, 0));\n  pointer-events: none;\n  left: 45.5% !important;\n  width: 3%;\n  height: 150%;\n  top: -25%;\n  transform: skewX(-8deg) translate(-5px, 10px);\n}\n\n.otherservicefirstpage-text-section h1 {\n  font-size: 3em;\n  margin-top: -20px;\n  margin-bottom: 10px;\n  z-index: 3;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.otherservicefirstpage-text-section p {\n  font-size: 1.5em;\n  text-align: center;\n  padding: 0 20px;\n  z-index: 3;\n}\n\n.container {\n  display: flex;\n  flex-direction: row;\n  padding: 20px;\n  gap: 20px;\n}\n\n.image-wrapper {\n  flex: 1;\n}\n\n.image {\n  width: 100%;\n  max-width: 400px;\n  border-radius: 8px;\n}\n\n.text-wrapper {\n  flex: 2;\n  padding: 10px;\n}\n\n.info-section {\n  margin: 20px 0;\n}\n\n@media (max-width: 768px) {\n  .otherservicefirstpage-container {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .otherservicefirstpage-image-section {\n    width: 100%;\n    height: 55vh;\n    clip-path: none;\n  }\n\n  .otherservicefirstpage-text-section {\n    width: 100%;\n    height: 40vh;\n    margin-top: 0px;\n    margin-left: 0;\n    clip-path: none;\n    padding: 0px;\n  }\n\n  .otherservicefirstpage-text-section h1 {\n    font-size: 2em;\n    margin-right: 100px;\n  }\n\n  .otherservicefirstpage-text-section p {\n    font-size: 1em;\n    margin-left: 5px;\n    text-align: left;\n  }\n\n  .otherservicefirstpage-container::before {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
